/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const GET_ACCESS_TOKEN = 'MFE/CHECKOUT/GET_WE_SALUTE_ACCESS_TOKEN';
export const SET_ACCESS_TOKEN = 'MFE/CHECKOUT/SELECT_WE_SALUTE_ACCESS_TOKEN';
export const CLEAR_ACCESS_TOKEN = 'MFE/CHECKOUT/CLEAR_WE_SALUTE_ACCESS_TOKEN';
